import React from 'react';

const CustomEAHero = () => {
  return (
    <section className="relative pt-24 pb-16 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto text-center overflow-hidden">
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-primary/5 blur-[120px] rounded-full -z-10"></div>
      <span className="text-primary font-label-sm tracking-[0.2em] uppercase mb-4 block">Tailored Trading Solutions</span>
      <h1 className="font-display-lg text-display-lg-mobile md:text-display-lg mb-6 leading-tight">
        Request Your <span className="text-gradient-gold">Custom EA</span><br/>Built for Precision.
      </h1>
      <p className="font-body-lg text-on-surface-variant max-w-2xl mx-auto mb-10">
        Turn your unique trading strategy into a fully automated MT4/MT5 Expert Advisor. Our senior developers build professional, optimized, and secure custom algorithms tailored to your exact requirements.
      </p>
    </section>
  );
};

export default CustomEAHero;
